(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savrane-product-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('savrane-product')) return;

    function formatWithDelimiters(cents, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (cents == null || isNaN(cents)) return '0';
      var parts = (cents / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    function formatMoney(cents, format) {
      var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var value;
      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
        case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ','); break;
        default: value = formatWithDelimiters(cents, 2);
      }
      return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
    }

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class SavraneProduct extends HTMLElement {
      connectedCallback() {
        var jsonEl = this.querySelector('[data-sv-product-json]');
        var fmtEl = this.querySelector('[data-sv-money-format]');
        if (!jsonEl) return;
        this.product = JSON.parse(jsonEl.textContent);
        this.moneyFormat = fmtEl ? JSON.parse(fmtEl.textContent) : 'Rs \x7b\x7bamount_no_decimals}}';
        this.idInput = this.querySelector('[data-sv-variant-id]');
        this.classList.add('sv-js');

        this.querySelectorAll('.sv-pill__input').forEach((input) => {
          input.addEventListener('change', () => this.onOptionChange());
        });

        this.setupQuantity();
        this.setupGallery();
        this.setupGift();
        this.setupAjaxForms();
        this.setupSticky();
        this.setupScrollToBuy();
        this.setupReveal();
      }

      /* ---------- Variants ---------- */
      onOptionChange() {
        var selected = [];
        this.querySelectorAll('[data-sv-option]').forEach((fieldset, i) => {
          var checked = fieldset.querySelector('input:checked');
          selected[i] = checked ? checked.value : null;
          var label = fieldset.querySelector('[data-sv-option-value]');
          if (label) label.textContent = selected[i] || '';
        });
        var variant = this.product.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        this.updateVariant(variant);
      }

      updateVariant(variant) {
        var addButtons = this.querySelectorAll('[data-sv-add]');
        var ds = this.dataset;
        this.currentAvailable = !!(variant && variant.available);

        if (!variant) {
          addButtons.forEach((btn) => {
            btn.disabled = true;
            this.setLabel(btn, ds.labelUnavailable);
          });
          this.syncBuyNow();
          return;
        }

        if (this.idInput) this.idInput.value = variant.id;

        this.querySelectorAll('[data-sv-price-now]').forEach((el) => {
          el.textContent = formatMoney(variant.price, this.moneyFormat);
        });

        var was = this.querySelector('[data-sv-price-was]');
        var save = this.querySelector('[data-sv-save]');
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (was) {
          was.hidden = !onSale;
          if (onSale) was.textContent = formatMoney(variant.compare_at_price, this.moneyFormat);
        }
        if (save) {
          save.hidden = !onSale;
          if (onSale) {
            var pct = Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
            save.textContent = ds.labelSave + ' ' + pct + '%';
          }
        }

        addButtons.forEach((btn) => {
          btn.disabled = !variant.available;
          this.setLabel(btn, variant.available ? ds.labelAdd : ds.labelSoldout);
        });
        this.syncBuyNow();

        if (variant.featured_media) this.goToMedia(variant.featured_media.id);

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      setLabel(btn, text) {
        var l = btn.querySelector('[data-sv-add-label]');
        if (l) l.textContent = text;
      }

      /* ---------- Gift bag ---------- */
      setupGift() {
        this.gift = this.querySelector('[data-sv-gift]');
        this.currentAvailable = !this.querySelector('[data-sv-add]') || !this.querySelector('[data-sv-add]').disabled;
        if (this.gift) this.gift.addEventListener('change', () => this.syncBuyNow());
      }

      syncBuyNow() {
        // "Buy it now" only buys the main product, so hide it while the gift bag is selected
        var buyNow = this.querySelector('[data-sv-buy-now]');
        if (!buyNow) return;
        var giftOn = this.gift && this.gift.checked;
        buyNow.hidden = !this.currentAvailable || giftOn;
      }

      /* ---------- Add to cart (AJAX, falls back to normal submit) ---------- */
      setupAjaxForms() {
        if (!window.fetch) return;
        var ds = this.dataset;
        var addUrl = (ds.cartAddUrl || '/cart/add') + '.js';
        var cartUrl = ds.cartUrl || '/cart';

        this.querySelectorAll('form[data-sv-ajax]').forEach((form) => {
          form.addEventListener('submit', (event) => {
            event.preventDefault();
            var isMain = form.getAttribute('data-sv-ajax') === 'main';
            var idField = form.querySelector('input[name="id"]');
            var qtyField = form.querySelector('input[name="quantity"]');
            if (!idField) { form.submit(); return; }

            var items = [{ id: parseInt(idField.value, 10), quantity: Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1) }];
            if (isMain && this.gift && this.gift.checked) {
              items.push({ id: parseInt(this.gift.value, 10), quantity: 1 });
            }

            var buttons = isMain
              ? Array.from(this.querySelectorAll('[data-sv-add]'))
              : Array.from(form.querySelectorAll('[data-sv-add-simple]'));
            var errorEl = form.querySelector('[data-sv-error]');
            if (errorEl) errorEl.hidden = true;

            buttons.forEach((b) => { b.classList.add('is-loading'); this.setLabel(b, ds.labelAdding); });

            fetch(addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items })
            })
              .then((res) => res.json().then((data) => ({ ok: res.ok, data: data })))
              .then((result) => {
                if (!result.ok) throw result.data;
                buttons.forEach((b) => { b.classList.remove('is-loading'); b.classList.add('is-added'); this.setLabel(b, ds.labelAdded); });
                setTimeout(() => { window.location.href = cartUrl; }, reduceMotion ? 0 : 550);
              })
              .catch((err) => {
                buttons.forEach((b) => { b.classList.remove('is-loading'); this.setLabel(b, ds.labelAdd); });
                if (errorEl) {
                  errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
                  errorEl.hidden = false;
                }
              });
          });
        });
      }

      /* ---------- Quantity ---------- */
      setupQuantity() {
        var input = this.querySelector('[data-sv-qty-input]');
        if (!input) return;
        this.querySelectorAll('[data-sv-qty]').forEach((btn) => {
          btn.addEventListener('click', () => {
            var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.svQty, 10);
            input.value = Math.max(1, next);
          });
        });
        input.addEventListener('change', () => {
          input.value = Math.max(1, parseInt(input.value, 10) || 1);
        });
      }

      /* ---------- Gallery ---------- */
      setupGallery() {
        this.track = this.querySelector('[data-sv-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('.sv-dot'));
        this.thumbs = Array.from(this.querySelectorAll('[data-sv-thumb]'));

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.goToIndex(parseInt(thumb.dataset.svThumb, 10)));
        });
        var prev = this.querySelector('[data-sv-prev]');
        var next = this.querySelector('[data-sv-next]');
        if (prev) prev.addEventListener('click', () => this.goToIndex(this.currentIndex() - 1));
        if (next) next.addEventListener('click', () => this.goToIndex(this.currentIndex() + 1));

        var ticking = false;
        this.track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => {
            this.setActive(this.currentIndex());
            ticking = false;
          });
        }, { passive: true });
      }

      currentIndex() {
        if (!this.track || !this.track.clientWidth) return 0;
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      goToIndex(index) {
        if (!this.slides || !this.slides.length) return;
        var total = this.slides.length;
        var i = ((index % total) + total) % total;
        this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        this.setActive(i);
      }

      goToMedia(mediaId) {
        if (!this.slides) return;
        var i = this.slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
        if (i > -1) this.goToIndex(i);
      }

      setActive(i) {
        this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        this.thumbs.forEach((t, n) => {
          t.classList.toggle('is-active', n === i);
          if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
      }

      /* ---------- Sticky bar ---------- */
      setupSticky() {
        var sticky = this.querySelector('[data-sv-sticky]');
        var buy = this.querySelector('[data-sv-buy]');
        if (!sticky || !buy || !('IntersectionObserver' in window)) return;
        var btn = sticky.querySelector('[data-sv-add]');
        var observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
            if (btn) btn.tabIndex = show ? 0 : -1;
          });
        });
        observer.observe(buy);
      }

      setupScrollToBuy() {
        this.querySelectorAll('[data-sv-scroll-buy]').forEach((link) => {
          link.addEventListener('click', (e) => {
            var target = this.querySelector('[data-sv-buy]');
            if (!target) return;
            e.preventDefault();
            target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          });
        });
      }

      /* ---------- Scroll reveal ---------- */
      setupReveal() {
        var items = this.querySelectorAll('[data-sv-reveal]');
        if (!items.length) return;
        if (reduceMotion || !('IntersectionObserver' in window) || !this.classList.contains('sv--animate')) {
          items.forEach((el) => el.classList.add('is-revealed'));
          return;
        }
        var io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
        items.forEach((el) => io.observe(el));
      }
    }

    customElements.define('savrane-product', SavraneProduct);
  })();

  } catch(e) { console.error(e); }
})();
})();
